// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SellerTemplate_sellerTemplatemain__uBpCA {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    /* height: 150px; */
    background-color: white;
    margin: 14px 0px;
    display: none;
    padding: 14px;
    border-radius: 20px;
}

.SellerTemplate_sellerTemplateImage__lOevN {
    /* border: 1px solid red; */
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;

}

.SellerTemplate_sellerTemplateImage__lOevN img {
    width: 100%;
    height: 100%;
    /* border: 1px solid rgb(27, 2, 255); */
    object-fit: contain;
    border-top-left-radius: 9px;
    border-bottom-left-radius: 9px;
}

.SellerTemplate_sellerTemplateDesc__oOkAW {
    width: 75%;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding-bottom: 5px;
    gap: 6px;
    /* border: 1px solid rgb(4, 245, 104); */
}

.SellerTemplate_sellerTemplateDesc_mail__5lwiG{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
}

.SellerTemplate_sellerTemplateDesc_mail__5lwiG> p{
    display: inline;
    width: 80%;
}

.SellerTemplate_sellerTemplateDesc__oOkAW button {
    background-color: #001AD5;
    border: none;
    outline: none;
    width: 87.94px;
    height: 27.84px;
    line-height: 14px;
    color: white;
    font-weight: 500;
    font-size: 12px;
    padding: 5px;

}

.SellerTemplate_sellerTemplateDesc__oOkAW p:nth-child(3) {
    color: #4F4F4F;
    font-weight: 800;
    font-size: 14px;
    line-height: 14px;
    padding-bottom: 3px
}

.SellerTemplate_sellerTemplateDesc__oOkAW p:nth-child(1) {
    color: #4F4F4F;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;

}

.SellerTemplate_sellerTemplateButtons__iskel {
    padding-top: 20px;
}

.SellerTemplate_success__FIfOh{
    background-color: #02D757 !important;
}
.SellerTemplate_danger__iRm8T{
    background-color: red !important;
}

@media screen and (max-width: 786px) {
    .SellerTemplate_sellerTemplateMain__br2f4 {
        display: block;
    }

    .SellerTemplate_sellerTemplateDesc__oOkAW p {
        display: inline-block;
    }
}

@media screen and (max-width: 375px) {

    .SellerTemplate_sellerTemplateDesc__oOkAW {
        gap: 5px;
    }

    .SellerTemplate_sellerTemplateDesc__oOkAW p {
        font-size: 12px !important;
    }

    .SellerTemplate_sellerTemplateImage__lOevN img {
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
    }

    .SellerTemplate_sellerTemplateDesc__oOkAW p:nth-child(3) {
        padding-bottom: 0px
    }

    /* .sellerTemplateDesc button {
        width: 80.94px;
        height: 27.84px;
    } */
}

@media screen and (max-width: 375px) {
    .SellerTemplate_sellerTemplatemain__uBpCA {
        padding: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/SellerViewTemplate/SellerTemplate.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,QAAQ;IACR,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,YAAY;;AAEhB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;;IAEI;QACI,QAAQ;IACZ;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI;IACJ;;IAEA;;;OAGG;AACP;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".sellerTemplatemain {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    /* height: 150px; */\n    background-color: white;\n    margin: 14px 0px;\n    display: none;\n    padding: 14px;\n    border-radius: 20px;\n}\n\n.sellerTemplateImage {\n    /* border: 1px solid red; */\n    width: 25%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.sellerTemplateImage img {\n    width: 100%;\n    height: 100%;\n    /* border: 1px solid rgb(27, 2, 255); */\n    object-fit: contain;\n    border-top-left-radius: 9px;\n    border-bottom-left-radius: 9px;\n}\n\n.sellerTemplateDesc {\n    width: 75%;\n    padding-left: 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    padding-bottom: 5px;\n    gap: 6px;\n    /* border: 1px solid rgb(4, 245, 104); */\n}\n\n.sellerTemplateDesc_mail{\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 5px;\n}\n\n.sellerTemplateDesc_mail> p{\n    display: inline;\n    width: 80%;\n}\n\n.sellerTemplateDesc button {\n    background-color: #001AD5;\n    border: none;\n    outline: none;\n    width: 87.94px;\n    height: 27.84px;\n    line-height: 14px;\n    color: white;\n    font-weight: 500;\n    font-size: 12px;\n    padding: 5px;\n\n}\n\n.sellerTemplateDesc p:nth-child(3) {\n    color: #4F4F4F;\n    font-weight: 800;\n    font-size: 14px;\n    line-height: 14px;\n    padding-bottom: 3px\n}\n\n.sellerTemplateDesc p:nth-child(1) {\n    color: #4F4F4F;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n\n}\n\n.sellerTemplateButtons {\n    padding-top: 20px;\n}\n\n.success{\n    background-color: #02D757 !important;\n}\n.danger{\n    background-color: red !important;\n}\n\n@media screen and (max-width: 786px) {\n    .sellerTemplateMain {\n        display: block;\n    }\n\n    .sellerTemplateDesc p {\n        display: inline-block;\n    }\n}\n\n@media screen and (max-width: 375px) {\n\n    .sellerTemplateDesc {\n        gap: 5px;\n    }\n\n    .sellerTemplateDesc p {\n        font-size: 12px !important;\n    }\n\n    .sellerTemplateImage img {\n        border-top-left-radius: 14px;\n        border-bottom-left-radius: 14px;\n    }\n\n    .sellerTemplateDesc p:nth-child(3) {\n        padding-bottom: 0px\n    }\n\n    /* .sellerTemplateDesc button {\n        width: 80.94px;\n        height: 27.84px;\n    } */\n}\n\n@media screen and (max-width: 375px) {\n    .sellerTemplatemain {\n        padding: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sellerTemplatemain": `SellerTemplate_sellerTemplatemain__uBpCA`,
	"sellerTemplateImage": `SellerTemplate_sellerTemplateImage__lOevN`,
	"sellerTemplateDesc": `SellerTemplate_sellerTemplateDesc__oOkAW`,
	"sellerTemplateDesc_mail": `SellerTemplate_sellerTemplateDesc_mail__5lwiG`,
	"sellerTemplateButtons": `SellerTemplate_sellerTemplateButtons__iskel`,
	"success": `SellerTemplate_success__FIfOh`,
	"danger": `SellerTemplate_danger__iRm8T`,
	"sellerTemplateMain": `SellerTemplate_sellerTemplateMain__br2f4`
};
export default ___CSS_LOADER_EXPORT___;
